import { render, staticRenderFns } from "./wizard_wrestlers.vue?vue&type=template&id=3f95b692&"
import script from "./wizard_wrestlers.vue?vue&type=script&lang=js&"
export * from "./wizard_wrestlers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports